import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import LocalStorage from '../../utils/localStorage';

class TransactionStore {
  @observable activeTabId = '1';
  @observable loadingData = false;
  @observable transactionLoading = false;

  @observable tabs = [
    { id: 1, name: 'Request', items: [] },
    { id: 2, name: 'In Progress', items: [] },
    { id: 3, name: 'Reserved', items: [] },
    // { id: 4, name: 'Schedule', items: [] }
  ];

  @observable orders = [];
  @observable totalPrice = 0;
  @observable totalOrder = 0;

  @observable showOrderDetailModal = false;
  @observable orderDetail = null;

  // Swipe
  @observable swipeX = 0;
  @observable isSwipe = false;

  // Initialization

  @action create(body) {
    this.transactionLoading = true;
    return ApiCaller.CmsTransactions.create(body).then(resp => {
      this.transactionLoading = false;
      return resp;
    });
  }

  @action get() {
    const tenantId = LocalStorage.Get('companyId');
    const roomNumber = LocalStorage.Get('roomNo');
    const guestId = LocalStorage.Get('customerId');
    let langName = window.localStorage.getItem('lang') || 'en';

    ApiCaller.CmsTransactions.get(tenantId, roomNumber, guestId, langName).then(resp => {
      if (resp) {
        if (resp.result) {
          if (resp.result.length > 0) {
            this.orders = resp.result.filter(fi => fi.taskName !== null);

            let requestOrders = this.tabs.find(fi => fi.id === 1);
            if (requestOrders) {
              requestOrders.items = this.orders.filter(fi => fi.stage === 1);
            }

            let inProgressOrders = this.tabs.find(fi => fi.id === 2);
            if (inProgressOrders) {
              inProgressOrders.items = this.orders.filter(fi => fi.stage === 5);
            }

            let reservedOrders = this.tabs.find(fi => fi.id === 3);
            if (reservedOrders) {
              reservedOrders.items = this.orders.filter(fi => fi.stage === 10);
            }

            let scheduleOrders = this.tabs.find(fi => fi.id === 4);
            if (scheduleOrders) {
              scheduleOrders.items = this.orders.filter(fi => fi.stage === 25);
            }

            this.totalOrder = this.orders.length;
            LocalStorage.Save('totalOrder', this.totalOrder);

            this.totalPrice = 0;

            this.orders.map(order => {
              this.totalPrice = this.totalPrice + order.amount;
              return this.totalPrice;
            });

            return;
          }
        }
      }

      this.orders = [];
      this.tabs.map(tab => {
        tab.items = [];
        return tab;
      });
      this.totalOrder = 0;
      LocalStorage.Save('totalOrder', this.totalOrder);
      this.totalPrice = 0;
    });
  }

  @action settransactionLoading(value) {
    this.transactionLoading = value;
  }

  @action setshowOrderDetailModal(value) {
    this.showOrderDetailModal = value;
  }

  @action setOrderDetail(value) {
    this.orderDetail = value;
  }

  @action setActiveTabId(tabId) {
    this.activeTabId = tabId;
}

  @action setSwipeX(value) {
    this.swipeX = value;
  }

  @action setIsSwipe(value) {
    this.isSwipe = value;
  }

  @action resetData() {
    this.orders = [];
    
    this.tabs = [
      { id: 1, name: 'Request', items: [] },
      { id: 2, name: 'In Progress', items: [] },
      { id: 3, name: 'Reserved', items: [] },
      { id: 4, name: 'Schedule', items: [] }
    ];

    this.totalOrder = 0;
    LocalStorage.Save('totalOrder', this.totalOrder);
    this.totalPrice = 0;
}
}

export default new TransactionStore();